import { Check, ChevronLeft, ChevronRight } from 'lucide-react'
import type { QueBoardResult } from './types'

export interface QueBoardNavigatorProps {
  total: number
  currentIndex: number
  results: QueBoardResult[]
  onSelect: (index: number) => void
  onPrev: () => void
  onNext: () => void
}

export function QueBoardNavigator({
  total,
  currentIndex,
  results,
  onSelect,
  onPrev,
  onNext,
}: QueBoardNavigatorProps) {
  return (
    <div className="flex items-center justify-center gap-2 py-3 px-4 bg-white/95 backdrop-blur-xs border-t border-gray-200">
      {/* 이전 버튼 */}
      <button
        onClick={onPrev}
        disabled={currentIndex === 0}
        className="p-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
      >
        <ChevronLeft className="w-5 h-5" />
      </button>

      {/* 문제 번호 인디케이터 */}
      <div className="flex items-center gap-1.5 px-2">
        {Array.from({ length: total }, (_, i) => {
          const isCurrent = i === currentIndex
          const isDone = results[i]?.completed ?? false

          return (
            <button
              key={i}
              onClick={() => onSelect(i)}
              className={`
                flex items-center justify-center w-8 h-8 rounded-full text-xs font-bold transition-all
                ${
                  isCurrent
                    ? 'bg-indigo-600 text-white ring-2 ring-indigo-300 scale-110'
                    : isDone
                    ? 'bg-green-500 text-white hover:bg-green-600'
                    : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
                }
              `}
            >
              {isDone && !isCurrent ? <Check className="w-4 h-4" /> : i + 1}
            </button>
          )
        })}
      </div>

      {/* 다음 버튼 */}
      <button
        onClick={onNext}
        disabled={currentIndex === total - 1}
        className="p-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
      >
        <ChevronRight className="w-5 h-5" />
      </button>
    </div>
  )
}
